export enum UserStatusEnum {
  NEW = 'new',
  FREE = 'free',
  SUBSCRIBED = 'subscribed',
  INACTIVE = 'inactive'
}

export enum SubscriptionTypeEnum {
  BASIC = 'basic',
  PRO = 'pro',
  ELITE = 'elite'
}
